import React, { useEffect, useCallback } from 'react';

export default function ImageLightbox({ src, alt, caption, isOpen, onClose }) {
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Escape') onClose();
    },
    [onClose]
  );

  useEffect(() => {
    if (!isOpen) return undefined;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div
      className="image-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={alt}
      onClick={onClose}
    >
      <button
        type="button"
        className="image-lightbox__close"
        onClick={onClose}
        aria-label="Close"
      >
        ×
      </button>
      <div className="image-lightbox__content" onClick={(e) => e.stopPropagation()}>
        <img src={src} alt={alt} className="image-lightbox__img" />
        {caption && <p className="image-lightbox__caption">{caption}</p>}
      </div>
    </div>
  );
}

export function ZoomableImage({ src, alt, caption }) {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="zoomable-image">
      <button
        type="button"
        className="zoomable-image__trigger"
        onClick={() => setOpen(true)}
        aria-label={`View full size: ${caption || alt}`}
      >
        <img src={src} alt={alt} className="zoomable-image__thumb" />
        <span className="zoomable-image__hint">Click to zoom</span>
      </button>
      {caption && <p className="zoomable-image__caption">{caption}</p>}
      <ImageLightbox
        src={src}
        alt={alt}
        caption={caption}
        isOpen={open}
        onClose={() => setOpen(false)}
      />
    </div>
  );
}
